import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  public slides = [
    { title: 'The biggest sale', subtitle: 'Special for today', image: '../../../../assets/images/slider/swiper/1.jpg' },
    { title: 'Summer collection', subtitle: 'New Arrivals On Sale', image: '../../../../assets/images/videos/explore.jpg' },
    { title: 'The biggest sale', subtitle: 'Special for today', image: '../../../../assets/images/slider/swiper/3.jpg' },
  ];

  ngOnInit() {
  }

}
